__turbopack_context__.v({
  "bottomContent": "LpFooter-module__1-uZeG__bottomContent",
  "column": "LpFooter-module__1-uZeG__column",
  "container": "LpFooter-module__1-uZeG__container",
  "footer": "LpFooter-module__1-uZeG__footer",
  "link": "LpFooter-module__1-uZeG__link",
  "linkList": "LpFooter-module__1-uZeG__linkList",
  "logo": "LpFooter-module__1-uZeG__logo",
  "logoButton": "LpFooter-module__1-uZeG__logoButton",
  "mainContent": "LpFooter-module__1-uZeG__mainContent",
  "socialButton": "LpFooter-module__1-uZeG__socialButton",
  "socialIcon": "LpFooter-module__1-uZeG__socialIcon",
  "socials": "LpFooter-module__1-uZeG__socials",
});
